import ApplicationAdapter from './application';

export default class SummaryPageAdapter extends ApplicationAdapter {
  pathForType() {
    return 'summary-pages';
  }
}
